import styles from './round-icon-button.module.scss';

import { MouseEventHandler } from 'react';

export interface RoundIconButtonProps {
  icon: string;
  active?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const RoundIconButton = (props: RoundIconButtonProps) => {
  return (
    <div className={[styles['round-icon-button'], props.active ? styles['active'] : undefined].join(' ')} onClick={props.onClick}>
      <i className={props.icon} />
    </div>
  );
};